// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppProjectsRouteImport } from './routes/_app/projects'
import { Route as AppProfileRouteImport } from './routes/_app/profile'
import { Route as AppPrivacyRouteImport } from './routes/_app/privacy'
import { Route as AppOpenLibraryRouteImport } from './routes/_app/openLibrary'
import { Route as AppCoachsRouteImport } from './routes/_app/coachs'
import { Route as AppStoreRouteRouteImport } from './routes/_app/store.route'
import { Route as PasswordRegisterIndexRouteImport } from './routes/password/register.index'
import { Route as PasswordLoginIndexRouteImport } from './routes/password/login.index'
import { Route as PasswordChangeIndexRouteImport } from './routes/password/change.index'
import { Route as AppProgramIndexRouteImport } from './routes/_app/program.index'
import { Route as AppForumIndexRouteImport } from './routes/_app/forum.index'
import { Route as AppEssayIndexRouteImport } from './routes/_app/essay.index'
import { Route as AppCoachingIndexRouteImport } from './routes/_app/coaching.index'
import { Route as AppAdminIndexRouteImport } from './routes/_app/admin.index'
import { Route as AppProgramProgramIdRouteImport } from './routes/_app/program.$programId'
import { Route as AppPaymentSuccessRouteImport } from './routes/_app/payment.success'
import { Route as AppJoinCodeRouteImport } from './routes/_app/join.$code'
import { Route as AppForumCreateRouteImport } from './routes/_app/forum.create'
import { Route as AppForumTagIdRouteImport } from './routes/_app/forum.$tagId'
import { Route as AppEssayWilksCalculatorRouteImport } from './routes/_app/essay/wilks-calculator'
import { Route as AppEssayWaterCalculatorRouteImport } from './routes/_app/essay/water-calculator'
import { Route as AppEssayMevMrvCalculatorRouteImport } from './routes/_app/essay/mev-mrv-calculator'
import { Route as AppEssayIpfGlCalculatorRouteImport } from './routes/_app/essay/ipf-gl-calculator'
import { Route as AppEssayFfmiCalculatorRouteImport } from './routes/_app/essay/ffmi-calculator'
import { Route as AppEssayCaloriCalculatorRouteImport } from './routes/_app/essay/calori-calculator'
import { Route as AppEssayBodyFatCalculatorRouteImport } from './routes/_app/essay/body-fat-calculator'
import { Route as AppEssay1rmCalculatorRouteImport } from './routes/_app/essay/1rm-calculator'
import { Route as AppEssayEssayIdRouteImport } from './routes/_app/essay.$essayId'
import { Route as AppAdminStoreRouteImport } from './routes/_app/admin.store'
import { Route as AppAdminProjectsRouteImport } from './routes/_app/admin.projects'
import { Route as AppAdminProgramsRouteImport } from './routes/_app/admin.programs'
import { Route as AppAdminPackagesRouteImport } from './routes/_app/admin.packages'
import { Route as AppAdminMediaRouteImport } from './routes/_app/admin.media'
import { Route as AppAdminHeroSlidesRouteImport } from './routes/_app/admin.hero-slides'
import { Route as AppAdminExercisesRouteImport } from './routes/_app/admin.exercises'
import { Route as AppAdminEssayRouteImport } from './routes/_app/admin.essay'
import { Route as AppAdminCatalogRouteImport } from './routes/_app/admin.catalog'
import { Route as AppAdminApplicationsRouteImport } from './routes/_app/admin.applications'
import { Route as AppStoreIndexRouteImport } from './routes/_app/store.index'
import { Route as AppAdminUsersIndexRouteImport } from './routes/_app/admin.users.index'
import { Route as AppAdminUsersUserIdRouteImport } from './routes/_app/admin.users.$userId'
import { Route as AppAdminProgramProgramIdRouteImport } from './routes/_app/admin.program.$programId'

const AppRoute = AppRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRoute
          })
const AppSettingsRoute = AppSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AppRoute
          })
const AppProjectsRoute = AppProjectsRouteImport.update({
            id: '/projects',path: '/projects',getParentRoute: () => AppRoute
          })
const AppProfileRoute = AppProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AppRoute
          })
const AppPrivacyRoute = AppPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => AppRoute
          })
const AppOpenLibraryRoute = AppOpenLibraryRouteImport.update({
            id: '/openLibrary',path: '/openLibrary',getParentRoute: () => AppRoute
          })
const AppCoachsRoute = AppCoachsRouteImport.update({
            id: '/coachs',path: '/coachs',getParentRoute: () => AppRoute
          })
const AppStoreRouteRoute = AppStoreRouteRouteImport.update({
            id: '/store',path: '/store',getParentRoute: () => AppRoute
          })
const PasswordRegisterIndexRoute = PasswordRegisterIndexRouteImport.update({
            id: '/password/register/',path: '/password/register/',getParentRoute: () => rootRouteImport
          })
const PasswordLoginIndexRoute = PasswordLoginIndexRouteImport.update({
            id: '/password/login/',path: '/password/login/',getParentRoute: () => rootRouteImport
          })
const PasswordChangeIndexRoute = PasswordChangeIndexRouteImport.update({
            id: '/password/change/',path: '/password/change/',getParentRoute: () => rootRouteImport
          })
const AppProgramIndexRoute = AppProgramIndexRouteImport.update({
            id: '/program/',path: '/program/',getParentRoute: () => AppRoute
          })
const AppForumIndexRoute = AppForumIndexRouteImport.update({
            id: '/forum/',path: '/forum/',getParentRoute: () => AppRoute
          })
const AppEssayIndexRoute = AppEssayIndexRouteImport.update({
            id: '/essay/',path: '/essay/',getParentRoute: () => AppRoute
          })
const AppCoachingIndexRoute = AppCoachingIndexRouteImport.update({
            id: '/coaching/',path: '/coaching/',getParentRoute: () => AppRoute
          })
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => AppRoute
          })
const AppProgramProgramIdRoute = AppProgramProgramIdRouteImport.update({
            id: '/program/$programId',path: '/program/$programId',getParentRoute: () => AppRoute
          })
const AppPaymentSuccessRoute = AppPaymentSuccessRouteImport.update({
            id: '/payment/success',path: '/payment/success',getParentRoute: () => AppRoute
          })
const AppJoinCodeRoute = AppJoinCodeRouteImport.update({
            id: '/join/$code',path: '/join/$code',getParentRoute: () => AppRoute
          })
const AppForumCreateRoute = AppForumCreateRouteImport.update({
            id: '/forum/create',path: '/forum/create',getParentRoute: () => AppRoute
          })
const AppForumTagIdRoute = AppForumTagIdRouteImport.update({
            id: '/forum/$tagId',path: '/forum/$tagId',getParentRoute: () => AppRoute
          })
const AppEssayWilksCalculatorRoute = AppEssayWilksCalculatorRouteImport.update({
            id: '/essay/wilks-calculator',path: '/essay/wilks-calculator',getParentRoute: () => AppRoute
          })
const AppEssayWaterCalculatorRoute = AppEssayWaterCalculatorRouteImport.update({
            id: '/essay/water-calculator',path: '/essay/water-calculator',getParentRoute: () => AppRoute
          })
const AppEssayMevMrvCalculatorRoute = AppEssayMevMrvCalculatorRouteImport.update({
            id: '/essay/mev-mrv-calculator',path: '/essay/mev-mrv-calculator',getParentRoute: () => AppRoute
          })
const AppEssayIpfGlCalculatorRoute = AppEssayIpfGlCalculatorRouteImport.update({
            id: '/essay/ipf-gl-calculator',path: '/essay/ipf-gl-calculator',getParentRoute: () => AppRoute
          })
const AppEssayFfmiCalculatorRoute = AppEssayFfmiCalculatorRouteImport.update({
            id: '/essay/ffmi-calculator',path: '/essay/ffmi-calculator',getParentRoute: () => AppRoute
          })
const AppEssayCaloriCalculatorRoute = AppEssayCaloriCalculatorRouteImport.update({
            id: '/essay/calori-calculator',path: '/essay/calori-calculator',getParentRoute: () => AppRoute
          })
const AppEssayBodyFatCalculatorRoute = AppEssayBodyFatCalculatorRouteImport.update({
            id: '/essay/body-fat-calculator',path: '/essay/body-fat-calculator',getParentRoute: () => AppRoute
          })
const AppEssay1rmCalculatorRoute = AppEssay1rmCalculatorRouteImport.update({
            id: '/essay/1rm-calculator',path: '/essay/1rm-calculator',getParentRoute: () => AppRoute
          })
const AppEssayEssayIdRoute = AppEssayEssayIdRouteImport.update({
            id: '/essay/$essayId',path: '/essay/$essayId',getParentRoute: () => AppRoute
          })
const AppAdminStoreRoute = AppAdminStoreRouteImport.update({
            id: '/admin/store',path: '/admin/store',getParentRoute: () => AppRoute
          })
const AppAdminProjectsRoute = AppAdminProjectsRouteImport.update({
            id: '/admin/projects',path: '/admin/projects',getParentRoute: () => AppRoute
          })
const AppAdminProgramsRoute = AppAdminProgramsRouteImport.update({
            id: '/admin/programs',path: '/admin/programs',getParentRoute: () => AppRoute
          })
const AppAdminPackagesRoute = AppAdminPackagesRouteImport.update({
            id: '/admin/packages',path: '/admin/packages',getParentRoute: () => AppRoute
          })
const AppAdminMediaRoute = AppAdminMediaRouteImport.update({
            id: '/admin/media',path: '/admin/media',getParentRoute: () => AppRoute
          })
const AppAdminHeroSlidesRoute = AppAdminHeroSlidesRouteImport.update({
            id: '/admin/hero-slides',path: '/admin/hero-slides',getParentRoute: () => AppRoute
          })
const AppAdminExercisesRoute = AppAdminExercisesRouteImport.update({
            id: '/admin/exercises',path: '/admin/exercises',getParentRoute: () => AppRoute
          })
const AppAdminEssayRoute = AppAdminEssayRouteImport.update({
            id: '/admin/essay',path: '/admin/essay',getParentRoute: () => AppRoute
          })
const AppAdminCatalogRoute = AppAdminCatalogRouteImport.update({
            id: '/admin/catalog',path: '/admin/catalog',getParentRoute: () => AppRoute
          })
const AppAdminApplicationsRoute = AppAdminApplicationsRouteImport.update({
            id: '/admin/applications',path: '/admin/applications',getParentRoute: () => AppRoute
          })
const AppStoreIndexRoute = AppStoreIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppStoreRouteRoute
          })
const AppAdminUsersIndexRoute = AppAdminUsersIndexRouteImport.update({
            id: '/admin/users/',path: '/admin/users/',getParentRoute: () => AppRoute
          })
const AppAdminUsersUserIdRoute = AppAdminUsersUserIdRouteImport.update({
            id: '/admin/users/$userId',path: '/admin/users/$userId',getParentRoute: () => AppRoute
          })
const AppAdminProgramProgramIdRoute = AppAdminProgramProgramIdRouteImport.update({
            id: '/admin/program/$programId',path: '/admin/program/$programId',getParentRoute: () => AppRoute
          })





const AppStoreRouteRouteChildren = {
  AppStoreIndexRoute: AppStoreIndexRoute
}

const AppStoreRouteRouteWithChildren = AppStoreRouteRoute._addFileChildren(AppStoreRouteRouteChildren)



const AppRouteChildren = {
  AppStoreRouteRoute: AppStoreRouteRouteWithChildren,AppCoachsRoute: AppCoachsRoute,AppOpenLibraryRoute: AppOpenLibraryRoute,AppPrivacyRoute: AppPrivacyRoute,AppProfileRoute: AppProfileRoute,AppProjectsRoute: AppProjectsRoute,AppSettingsRoute: AppSettingsRoute,AppIndexRoute: AppIndexRoute,AppAdminApplicationsRoute: AppAdminApplicationsRoute,AppAdminCatalogRoute: AppAdminCatalogRoute,AppAdminEssayRoute: AppAdminEssayRoute,AppAdminExercisesRoute: AppAdminExercisesRoute,AppAdminHeroSlidesRoute: AppAdminHeroSlidesRoute,AppAdminMediaRoute: AppAdminMediaRoute,AppAdminPackagesRoute: AppAdminPackagesRoute,AppAdminProgramsRoute: AppAdminProgramsRoute,AppAdminProjectsRoute: AppAdminProjectsRoute,AppAdminStoreRoute: AppAdminStoreRoute,AppEssayEssayIdRoute: AppEssayEssayIdRoute,AppEssay1rmCalculatorRoute: AppEssay1rmCalculatorRoute,AppEssayBodyFatCalculatorRoute: AppEssayBodyFatCalculatorRoute,AppEssayCaloriCalculatorRoute: AppEssayCaloriCalculatorRoute,AppEssayFfmiCalculatorRoute: AppEssayFfmiCalculatorRoute,AppEssayIpfGlCalculatorRoute: AppEssayIpfGlCalculatorRoute,AppEssayMevMrvCalculatorRoute: AppEssayMevMrvCalculatorRoute,AppEssayWaterCalculatorRoute: AppEssayWaterCalculatorRoute,AppEssayWilksCalculatorRoute: AppEssayWilksCalculatorRoute,AppForumTagIdRoute: AppForumTagIdRoute,AppForumCreateRoute: AppForumCreateRoute,AppJoinCodeRoute: AppJoinCodeRoute,AppPaymentSuccessRoute: AppPaymentSuccessRoute,AppProgramProgramIdRoute: AppProgramProgramIdRoute,AppAdminIndexRoute: AppAdminIndexRoute,AppCoachingIndexRoute: AppCoachingIndexRoute,AppEssayIndexRoute: AppEssayIndexRoute,AppForumIndexRoute: AppForumIndexRoute,AppProgramIndexRoute: AppProgramIndexRoute,AppAdminProgramProgramIdRoute: AppAdminProgramProgramIdRoute,AppAdminUsersUserIdRoute: AppAdminUsersUserIdRoute,AppAdminUsersIndexRoute: AppAdminUsersIndexRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren = {
  AppRoute: AppRouteWithChildren,PasswordChangeIndexRoute: PasswordChangeIndexRoute,PasswordLoginIndexRoute: PasswordLoginIndexRoute,PasswordRegisterIndexRoute: PasswordRegisterIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)